export enum Web3InteractionSuccessType {
  Claim = 'claim'
}
